import React, {  useEffect } from 'react';
import Landing from "../src/Containers/landing/landing"
import Examiner from "../src/Containers/examiner/examiner"
import Batchtable from "../src/Containers/batch/batchtable"
import Extratable from "../src/Containers/extra/extratable"
import Awlblank from "../src/Containers/extra/awlblank"
import Examinerreport from "../src/Containers/batch/examinerreport"
import Billstat from "../src/Containers/billstatement/billstat"
import Statement from "../src/Containers/billstatement/billstatement"
import AwlReprint from "./Containers/batch/awlreprint"
import AwlPrint from "./Containers/batch/awlprint"
import Citychange from "./Containers/citychange/citychange"
import Main from "../src/Containers/main/main"
import Billprint from "../src/Containers/billstatement/billprint"
import Prcentre from "../src/Containers/examcentre/prcentre"
import './App.css';

//import asyncComponent from '../src/hoc/asyncComponent/asyncComponent';
import {connect} from 'react-redux';
import * as actions from './store/actions/index';
import {Route, Switch, Redirect} from 'react-router-dom';
//import Logout from '../src/Containers/Auth/logout/logout';

//const asyncAuth = asyncComponent(() => {
//  return import('./Containers/Auth/Auth')
//});
function App(props) {
  useEffect(() => {
    props.onTryAutoSignup();
  });
  let routes = (
      <Switch>
        <Route path="/" exact component={Landing} />
        <Redirect to="/" />
    </Switch>
      );
  if (props.isAuth)
    routes = (
    <Switch>
      <Route path="/Main" exact component={Main} />
      <Route path="/Batchtable" exact component={Batchtable} />
      <Route path="/Examinerreport" exact component={Examinerreport} />
      <Route path="/Examiner" exact component={Examiner} />
      <Route path="/Billstat" exact component={Billstat} />
      <Route path="/Statement" exact component={Statement} />
      <Route path="/BillPrint" exact component={Billprint} />
      <Route path="/EXTRACOPIES" exact component={Extratable} />
      <Route path="/AWLBLANK" exact component={Awlblank} />
      <Route path="/AwlPrint" exact component={AwlPrint} />
      <Route path="/AWLREPRINT" exact component={AwlReprint} />
      <Route path="/CITYCHANGE" exact component={Citychange} />
      <Route path="/PRCENTRE" exact component={Prcentre} />
      <Route path="/" exact component={Landing} />
      <Redirect to="/" />
  </Switch>
    )

    return (
    <div >
      {routes}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuth:state.auth.token !== null,
    isAdmin:state.auth.isAdmin
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup:() => dispatch(actions.authCheckState())
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(App);
